var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemps3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.145 19.6545C214.655 18.5045 212.265 17.9146 208.645 17.9146C198.285 17.9146 192.755 24.8246 192.755 36.6746C192.755 45.0846 196.615 52.1646 206.115 52.1646C213.715 52.1646 219.105 47.8746 219.105 40.1846C219.105 32.4946 213.665 29.2545 207.655 29.2545C204.515 29.2545 201.975 30.4546 200.675 32.0746C201.455 22.8846 211.065 23.6946 216.545 26.3446L217.145 19.6545ZM206.215 35.5045C209.075 35.5045 211.365 37.5346 211.365 40.4246C211.365 43.3146 209.075 45.3546 206.215 45.3546C203.355 45.3546 201.055 43.3146 201.055 40.4246C201.055 37.5346 203.355 35.5045 206.215 35.5045Z",
    fill: "#F97E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.895 248.405L32.0349 172.035L32.225 31.9746L164.085 108.355L163.895 248.405Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.025 152.975L32.165 76.6046L32.2251 31.9746L164.085 108.355L164.025 152.975Z",
    fill: "#B2E8C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.205 113.325L42.395 100.695L42.4249 79.6145L64.235 92.2445L64.205 113.325Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0348 130.605L72.2349 117.975L72.2649 96.8945L94.0648 109.525L94.0348 130.605Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.875 147.885L102.065 135.255L102.095 114.175L123.895 126.805L123.875 147.885Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.705 165.165L131.905 152.535L131.935 131.455L153.735 144.085L153.705 165.165Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1649 140.135L42.355 127.505L42.385 106.425L64.1949 119.055L64.1649 140.135Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9949 157.415L72.1948 144.785L72.2249 123.705L94.0249 136.335L93.9949 157.415Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123.835 174.695L102.035 162.065L102.065 140.985L123.865 153.615L123.835 174.695Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M153.675 191.975L131.865 179.345L131.895 158.265L153.695 170.895L153.675 191.975Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.125 166.945L42.325 154.315L42.355 133.235L64.155 145.855L64.125 166.945Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.965 184.225L72.155 171.595L72.1849 150.515L93.995 163.135L93.965 184.225Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.795 201.505L101.995 188.875L102.025 167.795L123.825 180.425L123.795 201.505Z",
    fill: "#29A063"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.395 98.9346L164.085 108.355L163.895 248.405L180.205 238.995L180.395 98.9346Z",
    fill: "#29A063"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.545 22.5649L32.2251 31.975L164.085 108.355L180.395 98.9349L48.545 22.5649Z",
    fill: "#72D09A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.865 122.385C127.635 119.355 123.385 111.985 123.395 105.945L123.415 89.9349C123.415 86.9149 124.485 84.795 126.205 83.815C127.925 82.825 130.295 82.975 132.915 84.485C138.145 87.515 142.395 94.8849 142.385 100.925L142.365 116.935C142.365 119.955 141.295 122.065 139.575 123.055C137.855 124.045 135.475 123.895 132.865 122.385Z",
    fill: "#72D09A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.555 85.2449C169.555 79.2149 165.315 71.8349 160.085 68.8049C157.465 67.2849 155.085 67.1449 153.365 68.1349L131.655 80.6849L126.205 83.815C127.925 82.825 130.295 82.975 132.915 84.485C138.145 87.515 142.395 94.8849 142.385 100.925L142.365 116.935C142.365 119.955 141.295 122.065 139.575 123.055L145.035 119.915C146.755 118.925 147.825 116.805 147.825 113.795L147.845 97.7949V98.9249L164.145 89.5049L169.555 92.6449V86.3849V85.2549V85.2449Z",
    fill: "#29A063"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4651 75.855C47.2351 72.825 42.9951 65.4549 42.9951 59.4249L43.0151 43.4149C43.0151 40.3949 44.0851 38.2749 45.8051 37.2949C47.5251 36.3049 49.8951 36.455 52.5151 37.965C57.7451 40.995 61.9951 48.3649 61.9851 54.4049L61.9651 70.4149C61.9651 73.4249 60.895 75.5449 59.175 76.5349C57.455 77.5249 55.0751 77.3749 52.4651 75.8649V75.855Z",
    fill: "#72D09A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6852 22.275C77.0652 20.755 74.6852 20.615 72.9652 21.605L51.2552 34.155L45.8052 37.285C47.5252 36.295 49.8953 36.445 52.5153 37.955C57.7453 40.985 61.9952 48.355 61.9852 54.395L61.9652 70.405C61.9652 73.415 60.8952 75.535 59.1752 76.525L64.6353 73.3849C66.3553 72.3949 67.4152 70.2749 67.4252 67.2649L67.4452 52.3849L83.7452 42.965L89.1553 46.1249V38.695C89.1653 32.665 84.9152 25.2849 79.6852 22.2549V22.275Z",
    fill: "#29A063"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.085 32.5249H168.285V38.5049H186.085V32.5249Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemps3);
export default __webpack_public_path__ + "static/media/temps3.16b67374c7cbcd03123a91f4444705a9.svg";
export { ForwardRef as ReactComponent };